<template>
  <!-- footer-content -->
  <div class="footer-wrap">
    <div class="company-wrap">
      <div class="company-logo">
        <img src="@/assets/images/nice-ci-footer.png" alt="NICE D&amp;B" />
      </div>
      <div class="footer-info">
        <div class="company-link">
          <a href="#" @click.prevent="openWinPop('https://www.nicednb.com/cp/company01.do');">회사소개</a>
          <span>|</span>
          <a
            href="#" @click.prevent="openWinPop('https://www.nicednb.com/cs/cs-center03-pp.do');"
            style="color:#5e95fb;"
          >개인정보처리방침</a>
          <span>|</span>
          <a href="#" @click.prevent="openWinPop('https://www.nicednb.com/cs/cs-center03-ci.do');">신용정보활용체제공시</a>
          <span>|</span>
          <a href="#" @click.prevent="openWinPop('https://www.nicednb.com/cs/cs-center03-ec.do');">이메일무단수집거부</a>
        </div>
        <div class="company-info">
          <div>
            <span>(주)나이스디앤비</span>
            <span>|</span>
            <span>통신판매업신고 : 제2012-서울마포-0168호</span>
            <span>|</span>
            <span>사업자등록번호 : 107-86-24874</span>
            <span>|</span>
            <span>TEL : 02-2122-2308</span>
            <span>|</span>
            <span>FAX : 02-2122-2528</span>
          </div>
          <div>
            <span>(04535) 서울특별시 중구 소공로 70 포스트타워 B동, 14층 (주)나이스디앤비</span>
          </div>
          <div>
            <span>COPYRIGHT 2006 NICE D&amp;B Co.,Ltd. ALL RIGHTS RESERVED.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /footer-content -->
</template>

<script>
import { openWinPop } from "@/utils/common";

export default {
  methods: {
    openWinPop(url, width, height) {
      openWinPop(url, width, height);
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}
</style>